import { useEffect, useRef } from "react";

const ETA_WINDOW_MS = 2 * 60 * 1000;

export const useImportEta = ({ importId, completedCount, totalCount, active }) => {
  const ref = useRef({ importId: undefined, samples: [] });
  if (ref.current.importId !== importId) ref.current = { importId, samples: [] };

  useEffect(() => {
    if (!active || completedCount == null) return;
    const s = ref.current.samples;
    if (s.length === 0 || s[s.length - 1].c !== completedCount) {
      s.push({ t: Date.now(), c: completedCount });
      const cutoff = Date.now() - ETA_WINDOW_MS;
      while (s.length > 2 && s[0].t < cutoff) s.shift();
    }
  }, [active, completedCount, importId]);

  if (!active) return undefined;
  const s = ref.current.samples;
  if (s.length < 2) return undefined;
  const progressed = s[s.length - 1].c - s[0].c;
  const elapsedMs = s[s.length - 1].t - s[0].t;
  if (progressed <= 0 || elapsedMs <= 0) return undefined;
  const remainingMs =
    ((totalCount - s[s.length - 1].c) * elapsedMs) / progressed;
  const mins = Math.ceil(remainingMs / 60000);
  if (mins <= 1) return "Less than a minute remaining";
  if (mins < 60) return `About ${mins} mins remaining`;
  const hrs = Math.ceil(mins / 60);
  return `About ${hrs} hour${hrs > 1 ? "s" : ""} remaining`;
};
